<style lang="scss">
  .my-bar-chart {
    /*border: black 1px solid;*/
    width: 100%;
    height: 400px;
    @media only screen and (min-width: 769px) {
      height: 540px;
    }
  }
</style>
<template>
  <v-container fluid>
    <v-row class="text-center">
      <v-snackbar
        v-model="alertMessageShow"
        :color="alertMessageColor"
        top vertical :timeout="alertMessageTimeout"
      >
        <span v-html="alertMessageText"></span>
        <v-btn color="pink" text
               @click="alertMessageShow = false"
        >
          Fermer
        </v-btn>
      </v-snackbar>
      <v-col cols="12" lg="4" >
        <v-card class="mx-auto">
          <v-card-title>Types de dégradations</v-card-title>
          <div id="chartTypeCount" ref="chartTypeCount" class="my-bar-chart">
            Graphique Répartition des types de dégradations
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" lg="8" >
        <v-card class="mx-auto">
          <v-card-title>Type de dégradations par secteurs</v-card-title>
        <div id="chartSector" ref="chartSector" class="my-bar-chart">
          Graphique Type de dégradations par secteurs
        </div>
        </v-card>
      </v-col>
      <v-col cols="12" lg="12" >
        <v-card class="mx-auto">
          <v-card-title>Type de dégradations par date (30 derniers jours)</v-card-title>
          <div id="chartDateCreated" ref="chartDateCreated" class="my-bar-chart">
            Graphique Type de dégradations par secteurs
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" lg="7" >
        <v-card class="mx-auto">
          <v-card-title>Type de dégradations par groupe d'annonceurs</v-card-title>
        <div id="chartGroupe" ref="chartGroupe" class="my-bar-chart">
          Graphique Type de dégradations par groupe d'annonceurs
        </div>
        </v-card>
      </v-col>
      <v-col cols="12" lg="5" >
        <v-card class="mx-auto">
          <v-card-title>Dégradations par groupes d'annonceurs</v-card-title>
          <div id="chartGroupeCount" ref="chartGroupeCount" class="my-bar-chart">
            Graphique Répartition des groupes d'annonceurs
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" lg="7" >
        <v-card class="mx-auto">
          <v-card-title>Type de dégradations par annonceurs</v-card-title>
          <div id="chartCreator" ref="chartCreator" class="my-bar-chart">
            Graphique Type de dégradations par annonceurs
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" lg="5" >
        <v-card class="mx-auto">
          <v-card-title>Dégradations par annonceurs</v-card-title>
          <div id="chartAnnonceurCount" ref="chartAnnonceurCount" class="my-bar-chart">
            Graphique Répartition des annonceurs
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { isNullOrUndefined } from 'cgil-html-utils';
// import echart from 'echarts';

import echart from 'echarts/lib/echarts';
import 'echarts/lib/chart/bar';
import 'echarts/lib/chart/pie';
import 'echarts/lib/component/title';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/legend';
import {
  APP,
  DEV,
  getLog,
} from '../config';
import stats from './Stats';

// MAY BE CAN TRY TO HAVE SOMETHING LIKE https://github.com/bensladden/vue-responsive-dash
// but in an easier way, with vuetify and persisting user layout choice in user profile

const MODULE_NAME = 'DashBoard';
const log = getLog(MODULE_NAME, 4, 2);
// specify chart configuration item and data
const getOptionMyChart = (dataObject, xField, xFieldRotation = 0) => ({
  title: {
    text: '',
  },
  // http://colorbrewer2.org/#type=qualitative&scheme=Set1&n=9
  // eslint-disable-next-line
  color: ['#e41a1c', '#377eb8', '#009688', '#4daf4a', '#984ea3', '#ff7f00', '#ffff33', '#a65628', '#f781bf', '#999999', '#555555'],
  // https://colorbrewer2.org/?type=diverging&scheme=RdYlBu&n=11
  // eslint-disable-next-line
  //color: ['#a50026', '#d73027', '#f46d43', '#fdae61', '#fee090', '#ffffbf', '#e0f3f8', '#abd9e9', '#74add1', '#4575b4', '#313695'],
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'shadow',
    },
  },
  legend: {
    right: '1px',
    data: ['Affichage sauvage', 'CID-encombrant', 'CID-sacs noirs', 'Déchets sauvage', 'Défaut propreté', 'Odeurs/urine', 'Pigeon', 'Souillures', 'Stickers', 'Stupéfiants', 'Tags', 'Tags propriétaires'],
  },
  grid: {
    left: '3%',
    right: '4%',
    bottom: '3%',
    containLabel: true,
  },
  xAxis: {
    axisLine: { show: false },
    axisTick: { show: true },
    axisLabel: {
      rotate: xFieldRotation,
    },
    splitArea: { show: true },
    splitLine: { show: true },
    data: dataObject[xField],
    // ["Est", "Hyper-centre", "Nord", "Ouest", "Sud"]

  },
  yAxis: {},
  series: [
    {
      name: 'Affichage sauvage',
      type: 'bar',
      data: dataObject['Affichage sauvage'],
    }, {
      name: 'CID-encombrant',
      type: 'bar',
      data: dataObject['CID-encombrant'],
    }, {
      name: 'CID-sacs noirs',
      type: 'bar',
      data: dataObject['CID-sacs noirs'],
    }, {
      name: 'Déchets sauvage',
      type: 'bar',
      data: dataObject['Déchets sauvage'],
    }, {
      name: 'Défaut propreté',
      type: 'bar',
      data: dataObject['Défaut propreté'],
    }, {
      name: 'Odeurs/urine',
      type: 'bar',
      data: dataObject['Odeurs/urine'],
    }, {
      name: 'Pigeon',
      type: 'bar',
      data: dataObject.Pigeon,
    }, {
      name: 'Souillures',
      type: 'bar',
      data: dataObject.Souillures,
    }, {
      name: 'Stickers',
      type: 'bar',
      data: dataObject.Stickers,
    }, {
      name: 'Stupéfiants',
      type: 'bar',
      data: dataObject['Stupéfiants'],
    }, {
      name: 'Tags',
      type: 'bar',
      data: dataObject.Tags,
    }, {
      name: 'Tags propriétaires',
      type: 'bar',
      data: dataObject['Tags propriétaires'],
    },
  ],
});


export default {
  name: 'DashBoard',
  props: [],
  data: () => ({
    appName: APP,
    isInDev: DEV,
    alertMessageShow: false,
    alertMessageText: 'Rien à signaler',
    alertMessageTimeout: 7000, // 7 sec par defaut
    alertMessageColor: 'success',
    isDataRetrieved: false,
    categoriesBySector: null,
    errorMessages: '',
  }),
  created() {
    this.initialize();
  },
  mounted() {
    log.t(`# ${MODULE_NAME} mounted()`);
  }, // end of mounted
  computed: {
  },

  watch: {
  },

  methods: {
    showMessage(msgText, msgType = 'info') {
      this.alertMessageColor = msgType;
      this.alertMessageText = msgText;
      this.alertMessageShow = true;
    },
    initialize() {
      log.t('# IN initialize() before call stats.getCategoriesBySector()');
      stats.getCategoriesBySector((data, errMessage) => {
        if (!isNullOrUndefined(data)) {
          const categoriesBySector = data;
          log.l('# IN initialize -> objet data :', categoriesBySector);
          this.isDataRetrieved = true;
          const secteurs = data.map((i) => i.secteur);
          log.l('# IN initialize -> secteurs :', secteurs);
          const fields = Object.getOwnPropertyNames(data[0]);
          log.l('# IN initialize -> fields :', fields);
          const transposed = {};
          // eslint-disable-next-line no-return-assign
          fields.map((fieldN) => transposed[fieldN] = data.map((record) => record[fieldN]));
          log.l('# IN initialize -> transposed data thanks to 2 nested map:', transposed);
          const myChart = echart.init(this.$refs.chartSector);
          // use configuration item and data specified to show chart
          myChart.setOption(getOptionMyChart(transposed, 'secteur'));
        } else {
          log.e(`# GOT ERROR IN initialize() in callback for stats.getCategoriesBySector() : ${errMessage}`);
          this.isDataRetrieved = false;
        }
      });
      log.t('# IN initialize() before call stats.getCategoriesByCreator()');
      stats.getCategoriesByCreator((data, errMessage) => {
        if (!isNullOrUndefined(data)) {
          // filter 'Administrator' from Array to remove initial import from Goeland
          const categoriesByCreators = data.filter((obj) => obj.creator_name !== 'Administrator');
          log.l('# IN initialize getCategoriesByCreator -> categoriesByCreators data :', categoriesByCreators);
          this.isDataRetrieved = true;
          const creators = categoriesByCreators.map((i) => i.creator_name);
          log.l('# IN initialize getCategoriesByCreator -> creator_name :', creators);
          const fields = Object.getOwnPropertyNames(categoriesByCreators[0]);
          log.l('# IN initialize getCategoriesByCreator -> fields :', fields);
          const transposed = {};
          // eslint-disable-next-line no-return-assign,max-len
          fields.map((fieldN) => transposed[fieldN] = categoriesByCreators.map((record) => record[fieldN]));
          log.l('# IN initialize -> transposed data thanks to 2 nested map:', transposed);
          const myChart = echart.init(this.$refs.chartCreator);
          // use configuration item and data specified to show chart
          myChart.setOption(getOptionMyChart(transposed, 'creator_name', 90));
        } else {
          log.e(`# GOT ERROR IN initialize() in callback for stats.getCategoriesBySector() : ${errMessage}`);
          this.isDataRetrieved = false;
        }
      });

      log.t('# IN initialize() before call stats.getCategoriesByGroup()');
      stats.getCategoriesByGroup((data, errMessage) => {
        if (!isNullOrUndefined(data)) {
          // filter 'Administrator' from Array to remove initial import from Goeland
          const categoriesByCreators = data.filter((obj) => obj.creator_name !== 'Administrator');
          log.l('# IN initialize getCategoriesByGroup -> categoriesByCreators data :', categoriesByCreators);
          this.isDataRetrieved = true;
          const creators = categoriesByCreators.map((i) => i.creator_name);
          log.l('# IN initialize getCategoriesByGroup -> creator_name :', creators);
          const fields = Object.getOwnPropertyNames(categoriesByCreators[0]);
          log.l('# IN initialize getCategoriesByGroup -> fields :', fields);
          const transposed = {};
          // eslint-disable-next-line no-return-assign,max-len
          fields.map((fieldN) => transposed[fieldN] = categoriesByCreators.map((record) => record[fieldN]));
          log.l('# IN initialize -> transposed data thanks to 2 nested map:', transposed);
          const myChart = echart.init(this.$refs.chartGroupe);
          // use configuration item and data specified to show chart
          myChart.setOption(getOptionMyChart(transposed, 'creator_name', 90));
        } else {
          log.e(`# GOT ERROR IN initialize() in callback for stats.getCategoriesBySector() : ${errMessage}`);
          this.isDataRetrieved = false;
        }
      });

      log.t('# IN initialize() before call stats.getCategoriesByDateCreated()');
      stats.getCategoriesByDateCreated((data, errMessage) => {
        if (!isNullOrUndefined(data)) {
          // filter 'Administrator' from Array to remove initial import from Goeland
          const categoriesByDateCreated = data.filter((obj) => obj.creator_name !== 'Administrator');
          log.l('# IN initialize getCategoriesByDateCreated -> categoriesByCreators data :', categoriesByDateCreated);
          this.isDataRetrieved = true;
          const datecreated = categoriesByDateCreated.map((i) => i.datecreated);
          log.l('# IN initialize getCategoriesByDateCreated -> creator_name :', datecreated);
          const fields = Object.getOwnPropertyNames(categoriesByDateCreated[0]);
          log.l('# IN initialize getCategoriesByCreator -> fields :', fields);
          const transposed = {};
          // eslint-disable-next-line no-return-assign,max-len
          fields.map((fieldN) => transposed[fieldN] = categoriesByDateCreated.map((record) => record[fieldN]));
          log.l('# IN initialize -> transposed data thanks to 2 nested map:', transposed);
          const myChart = echart.init(this.$refs.chartDateCreated);
          // use configuration item and data specified to show chart
          myChart.setOption(getOptionMyChart(transposed, 'datecreated', 90));
        } else {
          log.e(`# GOT ERROR IN initialize() in callback for stats.getCategoriesBySector() : ${errMessage}`);
          this.isDataRetrieved = false;
        }
      });

      log.t('# IN initialize() before call stats.getCategoriesCount()');
      stats.getCategoriesCount((data, errMessage) => {
        if (!isNullOrUndefined(data)) {
          // filter 'Administrator' from Array to remove initial import from Goeland
          const categoriesCount = data.filter((obj) => obj.creator_name !== 'Administrator');
          log.l('# IN initialize getCategoriesCount -> categoriesCount data :', categoriesCount);
          this.isDataRetrieved = true;
          const catNames = categoriesCount.map((i) => i.name);
          log.l('# IN initialize getCategoriesByCreator -> catNames :', catNames);
          const myChart = echart.init(this.$refs.chartTypeCount);
          // use configuration item and data specified to show chart
          const option = {
            /* title: {
              text: 'Types de dégradations',
              subtext: '',
              x: 'center',
            }, */
            // eslint-disable-next-line
            // color: ['#a50026', '#d73027', '#f46d43', '#fdae61', '#fee090', '#ffffbf', '#e0f3f8', '#abd9e9', '#74add1', '#4575b4', '#313695'],
            color: ['#e41a1c', '#377eb8', '#009688', '#4daf4a', '#984ea3', '#ff7f00', '#ffff33', '#a65628', '#f781bf', '#999999', '#555555'],
            tooltip: {
              trigger: 'item',
              formatter: '{b} : {c} ({d}%)',
            },
            legend: {
              orient: 'vertical',
              left: 'left',
              data: catNames,
            },
            series: [
              {
                name: '',
                type: 'pie',
                radius: '65%',
                center: ['55%', '55%'],
                data: categoriesCount,
                itemStyle: {
                  emphasis: {
                    shadowBlur: 0,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0)',

                  },
                },
              },
            ],
          };
          myChart.setOption(option);
        } else {
          log.e(`# GOT ERROR IN initialize() in callback for stats.getCategoriesBySector() : ${errMessage}`);
          this.isDataRetrieved = false;
        }
      });

      log.t('# IN initialize() before call stats.getCountByUser()');
      stats.getCountByUser((data, errMessage) => {
        if (!isNullOrUndefined(data)) {
          // filter 'Administrator' from Array to remove initial import from Goeland
          const CountByUser = data.filter((obj) => obj.creator_name !== 'Administrator');
          log.l('# IN initialize getCountByUser -> CountByUser data :', CountByUser);
          this.isDataRetrieved = true;
          const catNames = CountByUser.map((i) => i.name);
          log.l('# IN initialize CountByUser -> catNames :', catNames);
          const myChart = echart.init(this.$refs.chartAnnonceurCount);
          // use configuration item and data specified to show chart
          const option = {
            /* title: {
              text: 'Types de dégradations',
              subtext: '',
              x: 'center',
            }, */
            tooltip: {
              trigger: 'item',
              formatter: '{b} : {c} ({d}%)',
            },
            legend: {
              orient: 'vertical',
              left: 'left',
              data: catNames,
            },
            series: [
              {
                name: '',
                type: 'pie',
                radius: '50%',
                center: ['60%', '50%'],
                data: CountByUser,
                itemStyle: {
                  emphasis: {
                    shadowBlur: 0,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0)',

                  },
                },
              },
            ],
          };
          myChart.setOption(option);
        } else {
          log.e(`# GOT ERROR IN initialize() in callback for stats.getCategoriesBySector() : ${errMessage}`);
          this.isDataRetrieved = false;
        }
      });

      log.t('# IN initialize() before call stats.getCountByGroupe()');
      stats.getCountByGroupe((data, errMessage) => {
        if (!isNullOrUndefined(data)) {
          // filter 'Administrator' from Array to remove initial import from Goeland
          const CountByUser = data.filter((obj) => obj.creator_name !== 'Administrator');
          log.l('# IN initialize getCountByGroupe -> CountByUser data :', CountByUser);
          this.isDataRetrieved = true;
          const catNames = CountByUser.map((i) => i.name);
          log.l('# IN initialize getCountByGroupe -> catNames :', catNames);
          const myChart = echart.init(this.$refs.chartGroupeCount);
          // use configuration item and data specified to show chart
          const option = {
            /* title: {
              text: 'Types de dégradations',
              subtext: '',
              x: 'center',
            }, */
            tooltip: {
              trigger: 'item',
              formatter: '{b} : {c} ({d}%)',
            },
            legend: {
              orient: 'vertical',
              left: 'left',
              data: catNames,
            },
            series: [
              {
                name: '',
                type: 'pie',
                radius: '50%',
                center: ['60%', '50%'],
                data: CountByUser,
                itemStyle: {
                  emphasis: {
                    shadowBlur: 0,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0)',

                  },
                },
              },
            ],
          };
          myChart.setOption(option);
        } else {
          log.e(`# GOT ERROR IN initialize() in callback for stats.getCategoriesBySector() : ${errMessage}`);
          this.isDataRetrieved = false;
        }
      });
    },
  }, // end of methods
};
</script>
